import * as cookies from 'js-cookie';

export function region(store) {

   return (store.region && store.region.code) || cookies.get('regions') || 'www';
}
